export const loadUsersnapSimulation = (event, api, language) => {
    // Check to see if the environment is production or stage depending on which vars are available.
    const productionKey = process.env.REACT_APP_USERSNAP_PROTOCOL_FEEDBACK_MENU;
    const stageKey = process.env.REACT_APP_USERSNAP_PROTOCOL_SME_FEEDBACK;

    // Additional satisfaction score widget.
    const satisfactionScoreKey = process.env.REACT_APP_USERSNAP_CONTENT_SATISFACTION_SCORE;

    // If the project apiKey matches the production, stage environment keys, show the widget.
    if(
        (event.apiKey === productionKey && language === "en") ||
        event.apiKey === stageKey ||
        (event.apiKey === satisfactionScoreKey && language === "en")
    ){
        api.show(event.apiKey);
    } else {
        // By default Usersnap shows all widgets in a space.
        // We want to hide the unused ones on load, so that we can rather
        // show specific widgets depending on content type and environment.
        api.hide(event.apiKey);
    }
}

export const loadUsersnapWidgets = (event, api, language) => {
    if( event.apiKey === process.env.REACT_APP_USERSNAP_WIDGET_FEEDBACK_MENU && language === "en" )
    {
        api.show(event.apiKey);
    } else {
        // By default Usersnap shows all widgets in a space.
        // We want to hide the unused ones on load, so that we can rather
        // show specific widgets depending on content type and environment.
        api.hide(event.apiKey);
    }
}

export const loadUsersnapScrollable = (event, api, language) => {
    if( event.apiKey === process.env.REACT_APP_USERSNAP_SCROLLABLE_REPORT_ISSUE && (language === "en" || language === null) )
    {
        api.show(event.apiKey);
    } else {
        // By default Usersnap shows all widgets in a space.
        // We want to hide the unused ones on load, so that we can rather
        // show specific widgets depending on content type and environment.
        api.hide(event.apiKey);
    }
}

export const loadUsersnapExperimentalDesign = (event, api, language) => {
    // Check to see if the environment is production or stage depending on which vars are available.
    const productionKey = process.env.REACT_APP_USERSNAP_EXPERIMENTAL_FEEDBACK_MENU;
    const stageKey = process.env.REACT_APP_USERSNAP_EXPERIMENTAL_SME_FEEDBACK;

    // If the project apiKey matches the production or stage environment keys, show the widget.
    if (
        (event.apiKey === productionKey && language === "en") ||
        event.apiKey === stageKey
    ) {
        api.show(event.apiKey);
    } else {
        // By default Usersnap shows all widgets in a space.
        // We want to hide the unused ones on load, so that we can rather
        // show specific widgets depending on content type and environment.
        api.hide(event.apiKey);
    }
}

export const loadUsersnapImageHotspot = (event, api, projectKey) => {
    // If the project apiKey matches the sceneData project key, show the widget.
    if (
        event.apiKey === projectKey
    ) {
        api.show(event.apiKey);
    } else {
        // By default Usersnap shows all widgets in a space.
        // We want to hide the unused ones on load, so that we can rather
        // show specific widgets depending on content type and environment.
        api.hide(event.apiKey);
    }
}
